<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'">
    <v-row dense>
      <v-col cols="6">
        <div class="titleName mb-5 mt-3 d-flex align-center">
          <v-img class="mr-3" max-width="18" src="@/assets/Dashboard/bar.svg"></v-img>
          <span>Top Performed IB</span>
        </div>
      </v-col>
         
      <v-col cols="6" class="d-flex align-center justify-end">
        <v-btn
          @click.prevent="downloadCSValltopib"
          :loading="csvLoading"
          :disabled="csvLoading"
          tile
          outlined
          elevation="0"
          small
          class="custom-btn-outline"
          color="#fff"
        >
          <span class="mdi mdi-tray-arrow-down mr-2"></span> Download CSV
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" md="9" lg="9">
        <v-text-field
          class="search-field mr-md-2 mb-md-0 mb-2"
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Search trade number ..."
          single-line
          solo
          hide-details
        />
      </v-col>

      <v-col cols="12" sm="6" md="3" lg="3">
        <v-select
          solo
          :items="ibDetailfilter"
          item-text="label"
          item-value="value"
          v-model="expenseShorting"
          label="Filter By: No Filter"
          append-icon="mdi-chevron-down"
          class="custom-select"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { IBREQUEST__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      isLoading: false,
      csvLoading: false,
      expenseShorting: "",
      isInitialLoading: false,
      searchTimeout: null,
    };
  },
  computed: {
    ...mapState("ibrequest", ["ibDetails", "ibDetailfilter", "topperformedlists"])
  },
  methods: {
    ...mapActions("ibrequest", [
      IBREQUEST__ACTIONS.TOPIBDETAILS,
      IBREQUEST__ACTIONS.TOPIBDETAILSFILTER,
      IBREQUEST__ACTIONS.ALLTOPPERFORMEDIB
    ]),

    async fetchTopIbs() {
      this.isInitialLoading = true;
      await this[IBREQUEST__ACTIONS.TOPIBDETAILS]({
        page: 1,
        limit: 10,
        search: this.search,
        filter_by: this.expenseShorting
      });
      this.isInitialLoading = false;
    },
    async downloadCSValltopib() {
      this.csvLoading = true;
      try {
        const params = {
          page: 1,
          limit: -1, // fetch all
          search: this.search || "",
          filter_by: this.expenseShorting || ""
        };
        await this[IBREQUEST__ACTIONS.ALLTOPPERFORMEDIB](params);
        this.downloadCSV();
      } catch (error) {
        console.error("Error downloading CSV:", error);
      } finally {
        this.csvLoading = false;
      }
    },

   downloadCSV() {
  this.csvLoading = true;
  console.log(this.topperformedlists);

  // Define CSV headers
  const headers = [
    "IB ID",
    "Name",
    "Email",
    "Total Clients",
    "Total Business",
    "New Clients",
    "Total Trading Volume",
    "Total Commission Earning",
    "Total Trade",
    "Performance Score"
  ];

  // Map the data to CSV rows
  const csvData = this.topperformedlists?.map(item => [
    item.ib_id,
    item.name,
    item.email,
    item.total_clients,
    item.total_business,
    item.new_clients,
    item.total_trading_volume,
    item.total_commission_earning,
    item.total_trade,
    item.performance_score
  ]);

  // Combine headers and rows into CSV content
  const csvContent = [headers, ...csvData]
    .map(row => row.join(","))
    .join("\n");

  // Create and trigger the CSV download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute(
    "download",
    `top-performed-ib-${new Date().toISOString().split("T")[0]}.csv`
  );
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  this.csvLoading = false;
  }

  },
  watch: {
  expenseShorting() {
    this.fetchTopIbs();
  },
  search: {
    handler(newVal) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchTopIbs(); 
      }, 500);
    },
    immediate: false,
  }
}
,
  mounted() {
    this[IBREQUEST__ACTIONS.TOPIBDETAILSFILTER]();
    this.fetchTopIbs();
  }
};
</script>
